import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import PhonebookLayer from "../components/PhonebookLayer";


const PhonebookList = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Phonebook" />


        {/* PhonebookLayer */}
        <PhonebookLayer />

      </MasterLayout>
    </>
  )
};

export default PhonebookList;
